import NewspaperExpirationMessageInput from './NewspaperExpirationMessageInput'
export default NewspaperExpirationMessageInput
